<template>
<kt-row>
    <kt-col lg="6" md="6" xs="12">
        <kt-form-group>
            <kt-form-label for="user_full_name">
                {{ $t('label.User_full_name') }} {{' :'}}
            </kt-form-label>
            <router-link :to="'/users/'+ psp_request.user_hashid +'/details'">
                {{psp_request.user_full_name}}
            </router-link>
        </kt-form-group>
    </kt-col>
    <kt-col lg="6" md="6" xs="12">
        <kt-form-group>
            <kt-form-label for="ref_farsi_name">
                {{ $t('label.ref_farsi_name') }}  {{' :'}}
            </kt-form-label>
            <router-link :to="'/gateways/'+ psp_request.ref.id +'/details'">
                {{psp_request.ref.farsi_name}}
            </router-link>
        </kt-form-group>
    </kt-col>
    <kt-col lg="6" md="6" xs="12">
        <kt-form-group>
            <kt-form-label for="followup_code">
                {{ $t('label.followup_code') }}
            </kt-form-label>
            <kt-form-control
                id="followup_code"
                name="followup_code"
                disabled
                :value="psp_request.followup_code"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col lg="6" md="6" xs="12">
        <kt-form-group>
            <kt-form-label for="psp">
                {{ $t('label.psp') }}
            </kt-form-label>
            <kt-form-control
                id="psp"
                name="psp"
                disabled
                :value="$t('psp_request_status.' + psp_request.psp)"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col lg="6" md="6" xs="12">
        <kt-form-group>
            <kt-form-label for="merchant_number">
                {{ $t('label.merchant_number') }}
            </kt-form-label>
            <kt-form-control
                id="merchant_number"
                name="merchant_number"
                disabled
                :value="psp_request.merchant_number"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    
    <kt-col lg="6" md="6" xs="12" >
        <kt-form-group>
            <kt-form-label for="terminal_number">
                {{ $t('label.terminal_number') }}
            </kt-form-label>
            <kt-form-control
                id="terminal_number"
                name="terminal_number"
                disabled
                :value="psp_request.terminal_number"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="created_at">
                {{ $t('label.created_at') }}
            </kt-form-label>
            <kt-form-control
                id="created_at"
                name="created_at"
                disabled
                dir="ltr"
                :value="psp_request.created_at"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="category_code">
                {{ $t('label.subcategory_key') }}
            </kt-form-label>
            <kt-form-control
                id="category_code"
                name="category_code"
                disabled
                :value="psp_request.category_code"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="ref_id">
                {{ $t('label.ref_id') }}
            </kt-form-label>
            <kt-form-control
                id="ref_id"
                name="ref_id"
                disabled
                :value="psp_request.ref.id"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="ref_farsi_name">
                {{ $t('label.ref_farsi_name') }}
            </kt-form-label>
            <kt-form-control
                id="ref_farsi_name"
                name="ref_farsi_name"
                disabled
                :value="psp_request.ref.farsi_name"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="ref_phone_number">
                {{ $t('label.phone_number') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="ref_phone_number"
                name="ref_phone_number"
                disabled
                :value="psp_request.ref.phone_number"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="ref_email_address">
                {{ $t('label.email') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="ref_email_address"
                name="ref_email_address"
                disabled
                :value="psp_request.ref.email_address"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="ref_website_address">
                {{ $t('label.website_address') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="ref_website_address"
                name="ref_website_address"
                disabled
                :value="psp_request.ref.website_address"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="ref_server_ip">
                {{ $t('label.server_ip') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="ref_server_ip"
                name="ref_server_ip"
                disabled
                :value="psp_request.ref.server_ip"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="message">
                {{ $t('label.psp_response') }}
            </kt-form-label>
            <textarea
                    id="message"
                    name="message"
                    class="form-control"
                    rows="8"
                    disabled
                    :value="psp_request.message"
            >
            </textarea>
        </kt-form-group>
    </kt-col>

</kt-row>
</template>

<script>
export default {
    props: {
        psp_request: {
            required: true,
        }
    }
}
</script>

<style>

</style>